import escapeRegExp from "lodash/escapeRegExp";
import trimStart from "lodash/trimStart";
export default (filterText, source) => {
    if (!filterText)
        return true;
    if (!source)
        return false;
    return new RegExp(escapeRegExp(trimStart(filterText)), "i").test(source);
};
